import { FaShop } from "react-icons/fa6";
import { ProductModel } from "@/types";

export interface ShopButtonProps {
  id: string;
  products: ProductModel[];
  fullscreen: boolean;
  onTapShopIcon: () => void;
}

const ShopButton = ({
  id,
  products = [],
  fullscreen,
  onTapShopIcon,
}: ShopButtonProps) => {
  return (
    <div
      className="tw-text-white hover:tw-cursor-pointer tw-flex tw-items-center tw-justify-center"
      onClick={onTapShopIcon}
    >
      <FaShop size="1.2rem" />
    </div>
  );
};

export default ShopButton;
